export default function Waiting(props) {
    const init_load = 0;
    const isLoading = props.visible;

    return (
        <div className={`waiting ` + (isLoading ? 'unloaded' : '') + (init_load ? ' initLoad' : '')}>
            <div className="icon-spinner"></div>
        </div>
    );
}
